import React from 'react';
import { Router, Switch, Redirect } from 'react-router-dom';
import history from './History';
import { ROUTE_PATHS } from '../utils/RoutesPaths';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
// ========= Components =========
import Admins from '../containers/Admins';
import Login from '../containers/Auth/Login';
import Services from '../containers/Services';
import Branches from '../containers/Branches';
import Specialties from '../containers/Specialties';
import AddBranch from '../containers/Branches/AddBranch';
import TempPassword from '../containers/Auth/TempPassword';
import ViewBranch from '../containers/Branches/ViewBranch';
import AddEditAdmin from '../containers/Admins/AddEditAdmin';
import ServiceProviders from '../containers/ServiceProviders';
import ChangePassword from '../containers/Auth/ChangePassword';
import ForgetPassword from '../containers/Auth/ForgetPassword';
import CoverageAreas from '../containers/Branches/CoverageAreas';
import SelectLocation from '../containers/Branches/SelectLocation';
import AddEditServices from '../containers/Services/AddEditServices';
import ViewSpecialties from '../containers/Specialties/ViewSpecialties';
import AddEditSpecialties from '../containers/Specialties/AddEditSpecialties';
import ServiceProviderCategories from '../containers/ServiceProviderCategories';
import ViewServiceProviders from '../containers/ServiceProviders/ViewServiceProviders';
import AddEditServiceProviders from '../containers/ServiceProviders/AddEditServiceProviders';
import ViewServiceProviderCategories from '../containers/ServiceProviderCategories/ViewServiceProviderCategories';
import AddEditServiceProviderCategories from '../containers/ServiceProviderCategories/AddEditServiceProviderCategories';
import Bookings from '../containers/Bookings'
import ViewBooking from '../containers/Bookings/ViewBooking'
import AddAnotherService from '../containers/Bookings/ViewBooking/AddAnotherService'
import PublishRequests from '../containers/PublishRequests';
import Settings from '../containers/Settings';
import CancellationPolicy from '../containers/Settings/CancellationPolicy';
import EditCancellationPolicy from '../containers/Settings/CancellationPolicy/EditCancellationPolicy';
import ChangePasswordSettings from '../containers/Settings/ChangePasswordSettings';
import MimarConstants from '../containers/Settings/MimarConstants';
import EditMimarConstants from '../containers/Settings/MimarConstants/EditMimarConstants';
import Employees from '../containers/Employees';
import ViewEmployeesDetails from '../containers/Employees/ViewEmployee';
import AddEditEmployee from '../containers/Employees/AddEditEmployee';
import Customers from '../containers/Customers';
import ViewCustomersDetails from '../containers/Customers/ViewCustomer';
import Notifications from "../containers/Notifications";
import PaymentTransactions from '../containers/Financial/PaymentTransactions';
import OutstandingBalance from '../containers/Financial/OutstandingBalance';
import ViewProviderOutstandingBalance from '../containers/Financial/OutstandingBalance/ViewProviderOutstadingBalance';
import LookupsRequests from '../containers/LookupsRequests';
import MimarProfit from '../containers/Financial/MimarProfit';


const Routes = (
  <Router history={history}>
    <Switch>
      {/* Admins Management */}
      <PrivateRoute component={Admins} path={ROUTE_PATHS.admins} exact permission={true} />
      <PrivateRoute component={AddEditAdmin} path={ROUTE_PATHS.addAdmin} exact permission={false} />
      <PrivateRoute component={AddEditAdmin} path={ROUTE_PATHS.editAdmin} exact permission={false} />

      {/* Categories Management */}
      <PrivateRoute
        component={ServiceProviderCategories}
        path={ROUTE_PATHS.serviceProviderCategories}
        exact
        permission={true}
      />
      <PrivateRoute
        component={AddEditServiceProviderCategories}
        path={ROUTE_PATHS.addServiceProviderCategories}
        exact
        permission={true}
      />
      <PrivateRoute
        component={AddEditServiceProviderCategories}
        path={ROUTE_PATHS.editServiceProviderCategories}
        exact
        permission={true}
      />
      <PrivateRoute
        component={ViewServiceProviderCategories}
        path={ROUTE_PATHS.viewServiceProviderCategories}
        exact
        permission={true}
      />

      {/* Specialties Management */}
      <PrivateRoute component={Specialties} path={ROUTE_PATHS.specialties} exact permission={true} />
      <PrivateRoute component={AddEditSpecialties} path={ROUTE_PATHS.addSpecialties} exact permission={true} />
      <PrivateRoute component={AddEditSpecialties} path={ROUTE_PATHS.editSpecialties} exact permission={true} />
      <PrivateRoute component={ViewSpecialties} path={ROUTE_PATHS.viewSpecialties} exact permission={true} />

      {/* Services Management */}
      <PrivateRoute component={Services} path={ROUTE_PATHS.services} exact permission={true} />
      <PrivateRoute component={AddEditServices} path={ROUTE_PATHS.addServices} exact permission={true} />
      <PrivateRoute component={AddEditServices} path={ROUTE_PATHS.editServices} exact permission={true} />

      {/* Lookups Requests */}
      <PrivateRoute component={LookupsRequests} path={ROUTE_PATHS.lookupsRequests} exact permission={true}/>

      {/* Providers Management */}
      <PrivateRoute component={ServiceProviders} path={ROUTE_PATHS.serviceProviders} exact permission={true} />
      <PrivateRoute
        component={AddEditServiceProviders}
        path={ROUTE_PATHS.addServiceProvider}
        exact
        permission={false}
      />
      <PrivateRoute
        component={AddEditServiceProviders}
        path={ROUTE_PATHS.editServiceProvider}
        exact
        permission={false}
      />
      <PrivateRoute component={ViewServiceProviders} path={ROUTE_PATHS.viewServiceProvider} exact permission={true} />
      {/* Branches */}
      <PrivateRoute component={Branches} path={ROUTE_PATHS.branches} exact permission={true} />
      <PrivateRoute component={ViewBranch} path={ROUTE_PATHS.viewBranch} exact permission={true} />
      <PrivateRoute component={AddBranch} path={ROUTE_PATHS.addProvidersBranch} exact permission={true} />
      <PrivateRoute component={AddBranch} path={ROUTE_PATHS.editProvidersBranch} exact permission={true} />
      <PrivateRoute
        component={CoverageAreas} 
        path={ROUTE_PATHS.addProvidersBranchSupportedRegions}
        exact
        permission={true}
      />
      <PrivateRoute
        component={SelectLocation}
        path={ROUTE_PATHS.addProvidersBranchBranchLocation}
        exact
        permission={true}
      />
      {/* Bookings */}
      <PrivateRoute component={Bookings} path={ROUTE_PATHS.bookings} exact permission={true} />
      <PrivateRoute component={ViewBooking} path={ROUTE_PATHS.viewBooking} exact permission={true} />
      <PrivateRoute component={AddAnotherService} path={ROUTE_PATHS.addAnotherServices} exact permission={true} />

      {/* PublishRequests */}
      <PrivateRoute component={PublishRequests} path={ROUTE_PATHS.publishRequests} exact permission={false} />
      <PrivateRoute component={ViewBranch} path={ROUTE_PATHS.viewPublishRequest} exact permission={false} />

      {/* Settings */}
      <PrivateRoute component={Settings} path={ROUTE_PATHS.settings} exact permission={true} />
      <PrivateRoute component={CancellationPolicy} path={ROUTE_PATHS.cancellationPolicy} exact permission={true} />
      <PrivateRoute component={EditCancellationPolicy} path={ROUTE_PATHS.editCancellationPolicy} exact permission={false}/>
      <PrivateRoute component={ChangePasswordSettings} path={ROUTE_PATHS.changePasswordFromSettings} exact permission={true}/>
      <PrivateRoute component={MimarConstants} path={ROUTE_PATHS.mimarConstants} exact permission={true} />
      <PrivateRoute component={EditMimarConstants} path={ROUTE_PATHS.editMimarConstants} exact permission={false} />

      {/* Authentication */}
      <PrivateRoute component={ChangePassword} path={ROUTE_PATHS.changePassword} exact permission={true} />
      <PublicRoute component={TempPassword} path={ROUTE_PATHS.tempPassword} exact />
      <PublicRoute component={ForgetPassword} path={ROUTE_PATHS.forgetPassword} exact />
      <PublicRoute component={Login} path={ROUTE_PATHS.login} exact />

      {/* Employees */}
      <PrivateRoute component={AddEditEmployee} path={ROUTE_PATHS.editEmployees} exact permission={true} />
      <PrivateRoute component={ViewEmployeesDetails} path={ROUTE_PATHS.viewEmployee} exact permission={true} />
      <PrivateRoute component={Employees} path={ROUTE_PATHS.employees} exact permission={true} />

      {/* customers */}
      <PrivateRoute component={ViewCustomersDetails} path={ROUTE_PATHS.viewCustomer} exact permission={true} />
      <PrivateRoute component={Customers} path={ROUTE_PATHS.customers} exact permission={true} />

      {/* Notifications */}
      <PrivateRoute component={Notifications} path={ROUTE_PATHS.notifications} exact permission={true} />
     
      {/* Financial */}
      <PrivateRoute component={PaymentTransactions} path={ROUTE_PATHS.transactions} exact permission={false} />
      <PrivateRoute component={OutstandingBalance} path={ROUTE_PATHS.settlements} exact permission={false} />
      <PrivateRoute component={ViewProviderOutstandingBalance} path={ROUTE_PATHS.viewSettlement} exact permission={false} />
      <PrivateRoute component={MimarProfit} path={ROUTE_PATHS.mimarProfit} exact permission={false} />


      <Redirect from="/" to={ROUTE_PATHS.admins} />
      <Redirect from="**" to={ROUTE_PATHS.admins} />
    </Switch>
  </Router>
);
export default Routes;
